/* infant-pdp-enhancements.js — runtime PDP improvements on Yuva theme.
 *
 * Above-fold trust stack (top→bottom):
 *   1. ⭐ Star rating (store-level Google reviews — explicit "magazin")
 *   2. 🚚 Trust strip — Livrare 2 zile • Retur 14 zile • Plată sigură (no COD)
 *   3. [product title]
 *   4. 📅 Estimated delivery date (+2 business days, with cutoff)
 *   5. 🏠 Seller info + WhatsApp
 *   6. ⚠️ Stock urgency when qty ≤ 3 (sticky bar)
 *
 * Honest signals only — no fake countdowns, no fake viewer counts. No COD
 * mentioned because we don't actually offer it (too many no-shows).
 */
(function () {
  if (!/\/products\//.test(location.pathname)) return;

  function el(html) {
    var t = document.createElement('template');
    t.innerHTML = html.trim();
    return t.content.firstChild;
  }

  function findInsertionAnchor() {
    var form = document.querySelector('form[action*="/cart/add"]');
    var anchor = null;
    if (form) {
      var p = form;
      for (var i = 0; i < 5 && p && p.parentNode; i++) {
        if (p.parentNode.querySelector('.product-view-name, .product-single__title, .product-title, h1, h2')) {
          anchor = p.parentNode.querySelector('.product-view-name, .product-single__title, .product-title, h1, h2');
          break;
        }
        p = p.parentNode;
      }
    }
    if (!anchor) {
      anchor = document.querySelector('.product-section h1') ||
               document.querySelector('.product-section h2') ||
               document.querySelector('.product-single__title');
    }
    return anchor;
  }

  // ─── unified trust card above anchor ───
  function insertAboveAnchor() {
    if (document.getElementById('infant-above-anchor')) return;
    var anchor = findInsertionAnchor();
    if (!anchor) return;

    var stars = '⭐⭐⭐⭐⭐';
    var card = el(
      '<div id="infant-above-anchor" style="margin:6px 0 10px;font-family:inherit;">' +
        // Row 1 — store-level rating, EXPLICITLY labeled
        '<a target="_blank" rel="noopener"' +
        ' href="https://www.google.com/maps/search/?api=1&query=Infant.ro&query_place_id=ChIJ_____" ' +
        ' style="display:inline-flex;align-items:center;gap:6px;text-decoration:none;' +
        'background:#fff8e7;border:1px solid #f6c948;padding:5px 10px;border-radius:18px;' +
        'font-size:12px;line-height:1.2;color:#5a3a00;font-weight:600;margin-bottom:6px;">' +
        '<span style="letter-spacing:1px;font-size:13px;">' + stars + '</span>' +
        '<span>5.0/5</span>' +
        '<span style="opacity:.75;font-weight:500;">· 30 recenzii Google despre magazin</span>' +
        '</a>' +

        // Row 2 — trust strip (NO COD, replaced with "Plată sigură")
        '<div style="' +
          'display:flex;justify-content:space-around;align-items:center;' +
          'gap:8px;padding:8px 10px;' +
          'background:linear-gradient(90deg,#fef6f3,#fef3ee);' +
          'border-radius:8px;font-size:12px;line-height:1.3;color:#333;' +
          'font-weight:500;text-align:center;flex-wrap:wrap;">' +
          '<span>🚚 Livrare 2 zile</span>' +
          '<span style="opacity:.3">•</span>' +
          '<span>🔄 Retur 14 zile</span>' +
          '<span style="opacity:.3">•</span>' +
          '<span>🔒 Plată sigură</span>' +
        '</div>' +
      '</div>'
    );
    anchor.parentNode.insertBefore(card, anchor);
  }

  // ─── below anchor: delivery date + seller info, in this order ───
  function computeDeliveryDate() {
    // +2 business days (was +1) — gives realistic Sameday buffer
    var now = new Date();
    var hour = now.getHours();
    var ship = new Date(now);
    if (hour >= 14) ship.setDate(ship.getDate() + 1);
    var deliver = new Date(ship);
    deliver.setDate(deliver.getDate() + 2);
    while (deliver.getDay() === 0 || deliver.getDay() === 6) {
      deliver.setDate(deliver.getDate() + 1);
    }
    return deliver;
  }
  function formatDateRO(d) {
    var weekdays = ['DUMINICĂ','LUNI','MARȚI','MIERCURI','JOI','VINERI','SÂMBĂTĂ'];
    var months   = ['IANUARIE','FEBRUARIE','MARTIE','APRILIE','MAI','IUNIE','IULIE','AUGUST','SEPTEMBRIE','OCTOMBRIE','NOIEMBRIE','DECEMBRIE'];
    return weekdays[d.getDay()] + ' ' + d.getDate() + ' ' + months[d.getMonth()];
  }
  function hoursUntilCutoff() {
    var now = new Date();
    var cutoff = new Date(now); cutoff.setHours(14, 0, 0, 0);
    if (now >= cutoff) return null;
    var ms = cutoff - now;
    return { h: Math.floor(ms / 3600000), m: Math.floor((ms % 3600000) / 60000) };
  }

  function insertBelowAnchor() {
    if (document.getElementById('infant-below-anchor')) return;
    var anchor = findInsertionAnchor();
    if (!anchor) return;

    var deliver = computeDeliveryDate();
    var cutoff = hoursUntilCutoff();
    var cutoffMsg = cutoff
      ? '<span style="font-weight:600;">Comandă în ' + cutoff.h + 'h ' + cutoff.m + 'min</span> și primești'
      : 'Comandată azi, primești';

    var card = el(
      '<div id="infant-below-anchor" style="margin:6px 0 8px;">' +
        // delivery (first, more important)
        '<div style="background:#e8f5e9;border-left:3px solid #2e7d32;padding:8px 12px;' +
          'margin-bottom:6px;border-radius:4px;font-size:13px;line-height:1.4;color:#1b5e20;">' +
          '🚚 ' + cutoffMsg + ' în 2 zile lucrătoare ' +
          '<span style="font-weight:700;">(' + formatDateRO(deliver) + ')</span>' +
          '<br><span style="font-size:11px;color:#558b2f;">📦 Deschiderea coletului la livrare este permisă</span>' +
        '</div>' +
        // seller info
        '<div style="background:#f5f5f5;padding:7px 12px;border-radius:4px;' +
          'font-size:11px;line-height:1.4;color:#555;text-align:center;">' +
          '🏠 Vândut și livrat de <strong>Infant.ro</strong> — magazin fizic în România' +
          '<br>💬 Întrebări? WhatsApp <a href="https://wa.me/40750234608" style="color:#2e7d32;text-decoration:underline;font-weight:600;">0750 234 608</a>' +
        '</div>' +
      '</div>'
    );
    anchor.parentNode.insertBefore(card, anchor.nextSibling);
  }

  // ─── stock urgency badge (sticky bar) ───
  var _productCache = null;
  function loadFullProduct(cb) {
    if (_productCache) return cb(_productCache);
    try {
      var handle = location.pathname.split('/products/')[1].split('/')[0].split('?')[0];
      fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) { _productCache = data; cb(data); })
        .catch(function () {});
    } catch (_) {}
  }
  function readSelectedVariantId() {
    try {
      var input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      return input ? input.value : null;
    } catch (_) { return null; }
  }
  function updateStockBadge() {
    loadFullProduct(function (prod) {
      if (!prod) return;
      var selVid = readSelectedVariantId();
      var variants = prod.variants || [];
      if (variants.length === 0) return;
      var sel = variants.find(function (v) { return String(v.id) === String(selVid); }) || variants[0];
      if (!sel) return;
      var qty = (sel.inventory_quantity != null) ? sel.inventory_quantity : null;
      var existing = document.getElementById('infant-stock-badge');
      if (existing) existing.remove();
      if (qty == null || qty > 3) return;

      var label, bg;
      if (qty <= 0) { label = 'Stoc indisponibil'; bg = '#9e9e9e'; }
      else if (qty === 1) { label = '⚠️ Doar 1 în stoc — comandă acum'; bg = '#d32f2f'; }
      else { label = '⚠️ Doar ' + qty + ' în stoc'; bg = '#f57c00'; }

      var badge = el(
        '<div id="infant-stock-badge" style="' +
          'background:' + bg + ';color:#fff;padding:6px 12px;font-size:12px;' +
          'font-weight:600;text-align:center;border-radius:4px;margin:0 0 6px;' +
          'animation:infant-pulse 2s ease-in-out infinite;">' + label + '</div>'
      );
      var sticky = document.querySelector('#yvProductStickyBar .container');
      if (sticky) {
        sticky.insertBefore(badge, sticky.firstChild);
      }
    });
  }

  function injectAnim() {
    if (document.getElementById('infant-pulse-anim')) return;
    var s = document.createElement('style');
    s.id = 'infant-pulse-anim';
    s.textContent = '@keyframes infant-pulse {0%,100%{opacity:1}50%{opacity:.7}}';
    document.head.appendChild(s);
  }

  var optionArrangeTimer = null;
  function isVisibleControl(node) {
    if (!node || node.closest('#yvProductStickyBar')) return false;
    var rect = node.getBoundingClientRect();
    return rect.width > 40 && rect.height > 10;
  }

  function arrangeOptionControls() {
    try {
      var detail = document.querySelector('.yv-main-product-detail') ||
                   document.querySelector('.product-section') ||
                   document.body;
      if (!detail) return;

      var options = Array.prototype.slice.call(
        detail.querySelectorAll('.option-selector, .select-marime.product-option-selector, .product-option-selector')
      ).filter(function (node, index, list) {
        return list.indexOf(node) === index && isVisibleControl(node);
      });
      var quantity = Array.prototype.slice.call(
        detail.querySelectorAll('.product-quantity-wrapper')
      ).filter(isVisibleControl)[0];
      if (!options.length && !quantity) return;

      var controls = options.slice();
      if (quantity) controls.push(quantity);
      var first = controls[0];
      if (!first || !first.parentNode) return;

      var grid = document.getElementById('infant-pdp-options-grid');
      if (!grid) {
        grid = document.createElement('div');
        grid.id = 'infant-pdp-options-grid';
        first.parentNode.insertBefore(grid, first);
      }
      grid.dataset.optionCount = String(options.length || 0);

      controls.forEach(function (control) {
        if (control.parentNode !== grid) grid.appendChild(control);
      });

      var guide = document.getElementById('infant-sg-trigger');
      if (guide && guide.previousElementSibling !== grid) {
        grid.insertAdjacentElement('afterend', guide);
      }
      var below = document.getElementById('infant-below-anchor');
      if (below && guide && below.previousElementSibling !== guide) {
        guide.insertAdjacentElement('afterend', below);
      }
    } catch (_) {}
  }

  function scheduleOptionControlsArrange() {
    clearTimeout(optionArrangeTimer);
    optionArrangeTimer = setTimeout(arrangeOptionControls, 50);
  }

  function bind() {
    try {
      injectAnim();
      // Wipe legacy elements from earlier deploys (clean rebuild)
      ['infant-trust-strip','infant-star-rating','infant-delivery-badge','infant-seller-info']
        .forEach(function (id) { var e = document.getElementById(id); if (e) e.remove(); });
      insertAboveAnchor();
      insertBelowAnchor();
      arrangeOptionControls();
      updateStockBadge();
      document.addEventListener('change', function (e) {
        var t = e.target;
        if (!t) return;
        if (t.matches && (t.matches('input[type=radio]') || t.matches('select[name*=option]') || t.matches('input[name="id"]'))) {
          scheduleOptionControlsArrange();
          setTimeout(updateStockBadge, 50);
        }
      }, true);
      try {
        new MutationObserver(scheduleOptionControlsArrange).observe(document.body, { childList: true, subtree: true });
      } catch (_) {}
      setTimeout(arrangeOptionControls, 400);
      setTimeout(arrangeOptionControls, 1400);
    } catch (_) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
